import React, { ComponentProps } from 'react';
import { FAB } from 'react-native-paper';
import PointIcon from '../CustomIcon';

type Props = ComponentProps<typeof FAB> | any;

const ActionButton: React.FC<Props> = (props) => {
  const { attributes, onPress } = props;
  const { nameIcon, backgroundColor, color, fontSize, opacity, zIndex } =
    attributes;

  const childProps: Props = {
    icon:
      nameIcon === 'point'
        ? () => <PointIcon width={24} height={24} fill={color} />
        : nameIcon,
    style: {
      opacity,
      fontSize,
      backgroundColor,
      color,
      width: 56,
      height: 56,
      zIndex,
    },
  };

  return <FAB onPress={onPress} {...childProps} />;
};

export default ActionButton;
